import React from 'react';
import { FiX, FiCheckCircle, FiAlertTriangle, FiInfo } from 'react-icons/fi';
import { useNotifications } from '../../contexts/NotificationContext';

const NotificationCenter = ({ onClose, variant = 'dark' }) => {
  const { notifications, markAsRead, markAllAsRead, isLoading } = useNotifications();

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'success':
        return <FiCheckCircle className="h-5 w-5 text-green-500" />;
      case 'error':
        return <FiAlertTriangle className="h-5 w-5 text-red-500" />;
      default:
        return <FiInfo className="h-5 w-5 text-blue-500" />;
    }
  };

  const closePanel = () => typeof onClose === 'function' && onClose();

  const isRead = (n) => Boolean(n?.is_read || n?.isRead || n?.read);
  const isDark = variant === 'dark';

  return (
    <div className={`w-80 rounded-lg shadow-lg z-50 ${isDark ? 'bg-slate-800 border border-slate-700 text-slate-100' : 'bg-white ring-1 ring-black ring-opacity-5'}`}>
      <div className={`p-4 border-b flex items-center justify-between ${isDark ? 'border-slate-700' : 'border-gray-200'}`}>
        <h3 className={`text-lg font-medium ${isDark ? 'text-white' : 'text-gray-900'}`}>Notifications</h3>
        <button onClick={closePanel} className={`${isDark ? 'text-slate-400 hover:text-slate-200' : 'text-gray-400 hover:text-gray-600'}`}>
          <FiX className="h-5 w-5" />
        </button>
      </div>

      <div className="max-h-96 overflow-y-auto">
        {isLoading ? (
          <div className={`p-4 text-center text-sm ${isDark ? 'text-slate-400' : 'text-gray-500'}`}>
            Chargement des notifications...
          </div>
        ) : notifications.length > 0 ? (
          notifications.map((notification) => (
            <div
              key={notification.id}
              className={`p-4 border-b cursor-pointer ${isDark ? 'border-slate-700 hover:bg-slate-700/50' : 'border-gray-100 hover:bg-gray-50'} ${!isRead(notification) ? (isDark ? 'bg-amber-500/10' : 'bg-amber-50') : ''}`}
              onClick={async () => {
                if (!isRead(notification)) {
                  await markAsRead(notification.id);
                }
              }}
            >
              <div className="flex items-start">
                <div className="flex-shrink-0 pt-0.5">{getNotificationIcon(notification.type)}</div>
                <div className="ml-3 flex-1">
                  <p className={`text-sm font-medium ${isDark ? 'text-white' : 'text-gray-900'}`}>{notification.title}</p>
                  <p className={`mt-1 text-sm ${isDark ? 'text-slate-300' : 'text-gray-500'}`}>{notification.message}</p>
                  <p className={`mt-1 text-xs ${isDark ? 'text-slate-400' : 'text-gray-400'}`}>
                    {new Date(notification.created_at || notification.createdAt || notification.timestamp || Date.now()).toLocaleString()}
                  </p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className={`p-4 text-center text-sm ${isDark ? 'text-slate-400' : 'text-gray-500'}`}>Aucune notification</div>
        )}
      </div>

      {notifications.length > 0 && (
        <div className={`p-3 text-right ${isDark ? 'bg-slate-900/40 border-t border-slate-700' : 'bg-gray-50'}`}>
          <button className="text-sm font-medium text-blue-600 hover:text-blue-500" onClick={markAllAsRead}>
            Tout marquer comme lu
          </button>
        </div>
      )}
    </div>
  );
};

export default NotificationCenter;
